import axios from './axios'

export const getConfig = async () => {
    try {
        return await axios.get(`/romons.users/api/getconfig`)
    } catch (error) {
        throw error
    }
}

export const saveConfig = async (req) => {
    try {
        return await axios.post(`/romons.users/api/saveconfig`, req)
    } catch (error) {
        throw error
    }
}

export const register = async (req) => {
    try {
        return await axios.post(`/romons.users/api/users`, req)
    } catch (error) {
        throw error
    }
} 

export const searchUser = async (req) => {
    try {
        return await axios.post(`/romons.users/api/users`, req)
    } catch (error) {
        throw error
    }
}

export const searchUserWithoutAgent = async (key) => {
    try {
        return await axios.get(`/romons.users/api/users/withoutagent/${key}`)
    } catch (error) {
        throw error
    }
}

export const getAgentTier = async () => {
    try {
        return await axios.get(`/romons.users/api/agent/tier`)
    } catch (error) {
        throw error
    }
}

export const saveAgentTier = async (req) => {
    try {
        return await axios.post(`/romons.users/api/agent/savetier`, req)
    } catch (error) {
        throw error
    }
}

export const searchAgentUsers = async (req) => {
    try {
        return await axios.post(`/romons.users/api/agent/users`, req)
    } catch (error) {
        throw error
    }
}

export const saveAgent = async (req) => {
    try {
        return await axios.post(`/romons.users/api/agent/save`, req)
    } catch (error) {
        throw error
    }
}

export const getUserDetail = async (uid) => {
    try {
        return await axios.get(`/romons.users/api/user/${uid}`)
    } catch (error) {
        throw error
    }
}

export const getRoles = async () => {
    try {
        return await axios.get(`/romons.users/api/roles`)
    } catch (error) {
        throw error
    }
}

export const getUserTier = async (uid) => {
    try {
        return await axios.get(`/romons.users/api/agent/tier/user/${uid}`)
    } catch (error) {
        throw error
    }
}